/**
 * Utility composable for text sanitization
 */
export default function () {
    /**
     * Removes HTML tags from a string and handles undefined/null values
     * @param {string|undefined|null} content - The content to sanitize
     * @param {Object} [options] - Optional configuration
     * @param {boolean} [options.preserveLineBreaks=false] - Convert <br> and </p> tags to newlines
     * @returns {string} Sanitized content
     */
    function sanitizeHtml(content, options = {}) {
        if (!content) return '';
        
        let sanitized = content;
        
        // Optionally preserve line breaks
        if (options.preserveLineBreaks) {
            sanitized = sanitized
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/<\/p>/gi, '\n')
                .replace(/<p>/gi, '');
        }
        
        // Remove all HTML tags
        return sanitized.replace(/<[^>]*>/g, '').trim();
    }

    return {
        sanitizeHtml
    };
}